import React from 'react'

function Error(){
  return (
    <div>
        <div className='flex justify-center mx-auto  h-screen  items-center text-4xl text-richblue-25'>
            Error 404 - Page Not Found 
        </div>

    </div>
  )
}

export default Error